import React from 'react'
import UserHome from '../../Components/User/UserHome'
import Booking from '../../Components/User/Bookings/Booking'

function BookingsPage() {
  return (
    <div>
      <UserHome/>
      <Booking/>
    </div>
  )
}

export default BookingsPage
